import { ArrowUpRight, Palette } from "lucide-react";
import { waLink } from "../../lib/arvi";
import { IMAGES } from "../../lib/images";

const ITEMS = [
  {
    id: "sarees",
    title: "Sarees",
    price: "From ₹28,000 - ₹45,000",
    desc: "Hand-Painted Sarees - Silk, Organze painted with decades of devotion. The ARVI signature.",
    img: IMAGES.collectionSaree,
  },
  {
    id: "suits",
    title: "Suits",
    price: "From ₹22,000 - ₹38,000",
    desc: "Hand-Painted Sarees Suits, Everyday heirlooms — motifs painted on breathable, pure fabrics.",
    img: IMAGES.collectionSuit,
  },
  {
    id: "bridal",
    title: "Bridal Masterpieces",
    price: "From ₹80,000 - ₹1,50,000",
    desc: "Hand-Painted Bridal Masterpieces - For the day that lives forever — intricate, full-body artistry.",
    img: IMAGES.collectionBridal,
  },
];

export default function Collections() {
  return (
    <section
      id="collections"
      data-testid="collections-section"
      className="relative bg-maroon text-ivory py-24 md:py-32 grain"
    >
      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 reveal">
          <div>
            <p className="text-overline text-gold mb-5">The Collections</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              Three canvases,
              <br />
              <span className="italic text-[hsl(var(--gold-soft))]">one devoted hand.</span>
            </h2>
          </div>
          <p className="max-w-md text-ivory/75 text-[15px] leading-relaxed">
            Every piece begins on blank silk and ends as a wearable work of art —
            never printed, never outsourced, never mass-produced.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
          {ITEMS.map((it, idx) => (
            <a
              key={it.id}
              href={waLink(`Hello ARVI, I'm interested in the ${it.title} collection. Could you share more details?`)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`collection-card-${it.id}`}
              className="group block reveal"
            >
              <div className="relative overflow-hidden aspect-[3/4] bg-maroon-deep">
                <img
                  src={it.img}
                  alt={it.title}
                  className="w-full h-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4 font-display italic text-gold/90 text-sm">
                  0{idx + 1}
                </div>
                <div className="absolute bottom-4 right-4 p-2 bg-ivory text-maroon opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <ArrowUpRight className="h-4 w-4" />
                </div>
              </div>
              <div className="mt-5 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display text-xl md:text-[22px] leading-snug">
                    {it.title}
                  </h3>
                  <p className="mt-2 text-[13px] text-ivory/65 leading-relaxed max-w-[260px]">
                    {it.desc}
                  </p>
                </div>
                <span className="shrink-0 text-overline text-gold whitespace-nowrap mt-1">
                  {it.price}
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* Custom-made highlight strip */}
        <div
          data-testid="custom-made-banner"
          className="mt-20 md:mt-24 border border-[hsl(var(--gold)/0.5)] p-8 md:p-12 reveal"
        >
          <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-8">
            <div className="md:col-span-1 flex md:justify-center">
              <span className="inline-flex items-center justify-center h-12 w-12 border border-gold/70 text-gold">
                <Palette className="h-5 w-5" strokeWidth={1.4} />
              </span>
            </div>
            <div className="md:col-span-7">
              <p className="text-overline text-gold mb-3">Every Piece, Custom-Made</p>
              <h3 className="font-display text-2xl md:text-[28px] leading-snug text-ivory">
                Saree, suit or bridal — each ARVI piece is painted to your story.
              </h3>
              <p className="mt-3 text-[14px] md:text-[15px] text-ivory/70 leading-relaxed max-w-2xl">
                Share your colours, motifs, occasion and budget. The artist
                designs and paints exclusively for you — no two ARVI pieces are
                ever the same.
              </p>
            </div>
            <div className="md:col-span-4 md:text-right">
              <a
                href={waLink("Hello ARVI, I'd like to place a custom order. Could we discuss design ideas, colours and pricing?")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="custom-order-cta"
                className="btn-cta-base btn-wa"
              >
                Start a Custom Order
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
